import React, { useState } from "react";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";
import "./mainContainer.scss";
function MainContainer(props) {
  const {handleCreate,handleLogOut,showCreateButton,showLogoutButton,isHistroyComp,showHomeButton}=props;
  const [showSidebar,setShowSidebar]=useState(true)
  return (
    <div>
      <Header 
      showSidebar={showSidebar} 
      setShowSidebar={setShowSidebar}
      handleCreate={handleCreate}
      handleLogOut={handleLogOut}
      showCreateButton={showCreateButton}
      showLogoutButton={showLogoutButton}
      isHistroyComp={isHistroyComp}
      showHomeButton={showHomeButton}
      />
      {showSidebar && <Sidebar />}
      <div
        style={{
          margin: "5px 15px",
          top: "69px",
          position: "relative",
          marginLeft: showSidebar ? "calc(21% + 15px)" : "15px",
          overflow: "auto",
        }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default MainContainer;
